import { Component } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social-pinterest',
    templateUrl: './freeway-layout-footer-social-pinterest.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialPinterestComponent {}
